module.exports = __webpack_public_path__ + "static/media/icon-linkedin.1686d418.svg";